import React from 'react';
import {
  Card,
  CardHeader,
  CardSection,
  SmallHeader,
  useBreakpoint,
  Layout,
  Button,
  Gutter,
} from '@axiom/ui';
import type { Candidate, CandidateWorkFeedFormFilter } from '@axiom/validation';

import { WorkFeedFiltersForm } from '../WorkFeedFiltersForm/WorkFeedFiltersForm';

export const WorkFeedFilters = ({
  candidate,
  filters,
}: {
  candidate: Candidate;
  filters: CandidateWorkFeedFormFilter;
}) => {
  const { isSmallScreen } = useBreakpoint();
  if (isSmallScreen) {
    return null;
  }
  return (
    <Card name="WORK_FEED_FILTERS">
      <CardHeader>
        <Layout position="middle space-between">
          <Gutter right="16px">
            <SmallHeader name="WORK_FEED_FILTERS_HEADER">Filters</SmallHeader>
          </Gutter>
          <Button
            name="WORK_FEED_FILTERS_CONFIGURE_ALERTS"
            pattern="secondary"
            variation="outline"
            to="../../../preferences/communications?scrollTo=alerts"
          >
            Configure Alerts
          </Button>
        </Layout>
      </CardHeader>
      <CardSection>
        <WorkFeedFiltersForm
          name="WORK_FEED_FILTERS_FORM"
          candidate={candidate}
          filters={filters}
          minimal
        />
      </CardSection>
    </Card>
  );
};
